import { render, staticRenderFns } from "./YunScroll.vue?vue&type=template&id=349551fe&scoped=true&"
import script from "./YunScroll.vue?vue&type=script&lang=js&"
export * from "./YunScroll.vue?vue&type=script&lang=js&"
import style0 from "./YunScroll.vue?vue&type=style&index=0&id=349551fe&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "349551fe",
  null
  
)

export default component.exports